module.exports = __webpack_public_path__ + "img/fundingProtectLogo4.595413ee.png";